import styled from 'styled-components'
import { rem } from 'polished'
import LuxPlusMonthTakeoverHero from './LuxPlusMonthTakeoverHero'
import LuxPlusMonthTakeoverJoiningFeeBanner from './LuxPlusMonthTakeoverJoiningFeeBanner'
import LuxPlusMonthTakeoverFinePrint from './LuxPlusMonthTakeoverFinePrint'
import LuxPlusMonthTakeoverBestHotelOffersCarousel from './LuxPlusMonthTakeoverBestHotelOffersCarousel'
import LuxPlusMonthTakeoverHiddenOfferCarousel from './LuxPlusMonthTakeoverHiddenOfferCarousel'
import LuxPlusMonthTakeoverTourOffersCarousel from './LuxPlusMonthTakeoverTourOffersCarousel'
import LuxPlusMonthTakeoverExperienceOffersCarousel from './LuxPlusMonthTakeoverExperienceOffersCarousel'
import LuxPlusLandingFlightsBanner from 'luxPlus/components/LandingPage/LuxPlusLandingFlightsBanner'
import { useCurrentSiteTakeover } from 'takeovers/utils/hooks/useCurrentSiteTakeover'
import { useAppSelector } from 'hooks/reduxHooks'
import { getHasLuxPlusInAnyRegion, getIsEnabledFlightsLuxPlusPricingInCurrentRegion } from 'luxPlus/selectors/featureToggle'
import useLuxPlusMonthTakeoverEnabledVerticals from '../hooks/useLuxPlusMonthTakeoverEnabledVerticals'
import { LUX_PLUS_MONTH_TAKEOVER_ID } from '../constants/luxPlusMonthTakeoverConstants'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import HttpStatus from 'components/Common/HttpStatus'
import LayoutContainer from 'components/Common/LayoutContainer'

const JoiningFeeBannerContainer = styled(LayoutContainer)`
  margin-top: ${rem(30)};
`

const FinePrintContainer = styled(LayoutContainer)`
  margin-top: ${rem(20)};
`

const ExperiencesAnchor = styled.div`
  scroll-margin-block-start: ${rem(20)};
`

function LuxPlusMonthTakeoverLandingPage() {
  const currentTakeover = useCurrentSiteTakeover()
  const enabledVerticals = useLuxPlusMonthTakeoverEnabledVerticals()
  // Region-independent membership check — a paid member should never see the joining-fee
  // waiver, regardless of which region they're currently browsing in (unlike
  // getCanRedeemLuxPlusBenefits, which requires the browsing region to match their
  // subscription's region).
  const hasLuxPlusInAnyRegion = useAppSelector(getHasLuxPlusInAnyRegion)
  const isLuxPlusFlightsBannerEnabled = useAppSelector(getIsEnabledFlightsLuxPlusPricingInCurrentRegion)

  if (currentTakeover?.id !== LUX_PLUS_MONTH_TAKEOVER_ID) {
    // page is only meant for when the LuxPlus+ Month campaign is active
    return <HttpStatus code={404}>
      <Error404PageWithOffers />
    </HttpStatus>
  }

  return <div>
    <LuxPlusMonthTakeoverHero />
    {!hasLuxPlusInAnyRegion && <JoiningFeeBannerContainer variant="large">
      <LuxPlusMonthTakeoverJoiningFeeBanner />
    </JoiningFeeBannerContainer>}
    <FinePrintContainer variant="large">
      <LuxPlusMonthTakeoverFinePrint />
    </FinePrintContainer>
    <LuxPlusMonthTakeoverHiddenOfferCarousel />
    {enabledVerticals.flights && isLuxPlusFlightsBannerEnabled && <LuxPlusLandingFlightsBanner />}
    {enabledVerticals.tours && <LuxPlusMonthTakeoverTourOffersCarousel />}
    <LuxPlusMonthTakeoverBestHotelOffersCarousel />
    {enabledVerticals.experiences && <ExperiencesAnchor id="lux-plus-month-experiences">
      <LuxPlusMonthTakeoverExperienceOffersCarousel />
    </ExperiencesAnchor>}
  </div>
}

export default LuxPlusMonthTakeoverLandingPage
